// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html[dir] .SP8HLOhfO1SEgNa6yKxYqA\\=\\={padding-bottom:env(safe-area-inset-bottom)}html[dir] .TW6PY8Ebe3WBZmJ0Sj\\+CVg\\=\\={padding-bottom:32px}", ""]);
// Exports
exports.locals = {
	"iOSSafeArea": "SP8HLOhfO1SEgNa6yKxYqA==",
	"unifiedSearchView": "TW6PY8Ebe3WBZmJ0Sj+CVg=="
};
module.exports = exports;
